export const GET_STORIES_API_INFO = 'GET_STORIES_API_INFO';
